import {
  IonImg,
} from '@ionic/react';
  
const FooterLogo = () => {
  return (
    <div className='footer'>
      <div className="logo slotcheck-logo">
        <IonImg src="assets/images/Slot-Check_AE9142LightGold.svg" />
      </div>
    </div>
    
  );
};
  
export default FooterLogo;
  